export { default as CompetitionCard } from './CompetitionCard';
export type {
	CompetitionCardModel,
	CompetitionCardProps,
	CompetitionEntryDetail,
	ImageEntry
} from './CompetitionCard';
